import { Box, Group, Paper, SimpleGrid, Stack, Text, Title } from "@mantine/core";
import { IconCash, IconHandGrab, IconMail } from "@tabler/icons-react";
import { User } from "../../../../gql/__generated__/graphql";

interface ProfileInfoPanelProps {
  profile: User;
}

const ProfileInfoPanel = ({ profile }: ProfileInfoPanelProps) => {
  return (
    <Paper shadow="xs" p="lg" withBorder>
      <Stack gap="xl">
        <Title order={3}>Info & Stats</Title>

        {/* Stats Grid */}
        <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="lg">
          {profile.email && (
            <Box>
              <Group gap="xs" mb="xs">
                <IconMail size={18} color="var(--mantine-color-primary-6)" />
                <Text fw={600} size="sm">
                  Email
                </Text>
              </Group>
              <Text size="sm" c="dimmed">
                {profile.email}
              </Text>
            </Box>
          )}

          {profile.createdAt && (
            <Box>
              <Text fw={600} size="sm" mb="xs">
                Member Since
              </Text>
              <Text size="sm" c="dimmed">
                {new Date(profile.createdAt).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                })}
              </Text>
            </Box>
          )}

          {profile.completedCollabs && (
            <Box>
              <Group gap="xs" mb="xs">
                <IconHandGrab
                  size={18}
                  color="var(--mantine-color-primary-6)"
                />
                <Text fw={600} size="sm">
                  Completed Collabs
                </Text>
              </Group>
              <Text size="sm" c="dimmed">
                {profile.completedCollabs}
              </Text>
            </Box>
          )}

          {profile.userType === "CREATOR" && profile.tiktokData?.creatorStats?.med_gmv_revenue?.value && (
            <Box>
              <Group gap="xs" mb="xs">
                <IconCash size={18} color="var(--mantine-color-primary-6)" />
                <Text fw={600} size="sm">
                  Monthly GMV
                </Text>
              </Group>
              <Text size="sm" c="dimmed">
                ${parseFloat(profile.tiktokData.creatorStats.med_gmv_revenue.value).toLocaleString()}
              </Text>
            </Box>
          )}
        </SimpleGrid>
      </Stack>
    </Paper>
  );
};

export default ProfileInfoPanel;
